export default {
  noSignalsSelected: 'Nie wybrano żadnych sygnałów. Użyj ustawień wstępnych lub trybu widoku eksperta, aby wybrać sygnały',
};
